import PropTypes from 'prop-types';
import { TicketHeader } from './TicketHeader';
import TicketBody from './TicketBody';
import { TicketFooter } from './TicketFooter';
import { TicketConversations } from './TicketConversations';
import { TicketReply } from './TicketReply';
import React from 'react';
import { useAutoAnimate } from '@formkit/auto-animate/react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { postTicketReply } from '../../../actions/freshdesk-actions';

const TicketList = ({
                      tickets,
                      handleOpenTickets,
                      openTickets,
                      classes,
                      setIsSnackbarOpen,
                      user,
                      userId,
                      conversations,
                      postTicketReply,
                    }) => {
  const isOpened = (ticketId) => openTickets.includes(ticketId);
  const isNotLastItem = (index) => index !== tickets.length - 1;
  const [animation] = useAutoAnimate();
  const { EMail } = user;
  
  return (
    <>
      {tickets.map((ticket, index) => (
        <div ref={animation} key={ticket.id} className={classes.taskContent}>
          <TicketHeader
            ticket={ticket}
            handleOpenTickets={handleOpenTickets}
            isOpened={isOpened}
            classes={classes}
          />
          
          {isOpened(ticket.id) && (
            <>
              <TicketBody ticket={ticket} classes={classes} />
              <TicketFooter ticket={ticket} classes={classes} />
              <TicketConversations ticketId={ticket.id}
                                   userId={userId}
                                   userEmail={EMail}
                                   conversations={conversations}
                                   classes={classes} />
  
              <TicketReply
                ticketId={ticket.id}
                userId={userId}
                email={EMail}
                classes={classes}
                setIsSnackbarOpen={setIsSnackbarOpen}
                postTicketReply={postTicketReply}
              />
            
            </>
          )}
          
          {isNotLastItem(index) && <span className={classes.dotsSection}>...</span>}
        </div>
      ))}
    </>
  );
};

TicketList.propTypes = {
  tickets: PropTypes.array.isRequired,
  handleOpenTickets: PropTypes.func.isRequired,
  openTickets: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  setIsSnackbarOpen: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  userId: PropTypes.number.isRequired,
  conversations: PropTypes.array.isRequired,
  postTicketReply: PropTypes.func.isRequired,
};

const decorate = compose(
  connect(store => ({
      user: store.user.profile,
      userId: store.freshdesk.freshdeskUserId,
      conversations: store.freshdesk.conversations,
    }),
    dispatch => bindActionCreators({ postTicketReply }, dispatch),
  ),
);

export default decorate(TicketList);
